import React from "react";

const ArtistMain = () => {
  return <div></div>;
};

export default ArtistMain;
